import script from "./CampaignTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignTable.vue?vue&type=script&setup=true&lang=js"

import "./CampaignTable.vue?vue&type=style&index=0&id=5fb0d4a2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb0d4a2"]])

export default __exports__